var _rect, _rect2, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 150,
    viewBox: "0 0 610 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 610,
    height: 150,
    rx: 4,
    fill: "#2B2E34"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5367_357305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 610,
    height: 150
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 610,
    height: 150,
    rx: 2,
    fill: "#F5F8FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5367_357305)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.836 77.6665C165.198 61.8782 171.298 46.6972 182.098 34.7083C186.94 29.8773 190.185 23.8002 191.431 17.2304C192.678 10.6606 191.87 3.88723 189.109 -2.24992C186.348 -8.38706 181.755 -13.618 175.9 -17.2941C170.044 -20.9702 163.184 -22.9297 156.169 -22.9297C149.154 -22.9297 142.293 -20.9702 136.438 -17.2941C130.582 -13.618 125.989 -8.38706 123.228 -2.24992C120.467 3.88723 119.66 10.6606 120.906 17.2304C122.152 23.8002 125.397 29.8773 130.239 34.7083V34.7581C136.604 42.0606 142.508 51.6943 146.203 66.1001C148.297 74.1199 151.437 78.9617 156.671 81.532C161.811 83.395 164.836 82.4186 164.836 77.6665Z",
    fill: "#41444B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1648 81.0024C39.8047 96.7878 33.7042 111.966 22.9029 123.951C18.0614 128.781 14.8163 134.859 13.57 141.428C12.3238 147.998 13.1312 154.771 15.8921 160.909C18.653 167.046 23.246 172.277 29.1016 175.953C34.9571 179.629 41.8176 181.588 48.8324 181.588C55.8473 181.588 62.7078 179.629 68.5633 175.953C74.4189 172.277 79.0119 167.046 81.7728 160.909C84.5337 154.771 85.3411 147.998 84.0948 141.428C82.8486 134.859 79.6035 128.781 74.762 123.951V123.901C68.3974 116.598 62.4934 106.965 58.7981 92.5588C56.7045 84.5889 53.564 79.6973 48.33 77.127C43.2111 75.2142 40.1648 76.1905 40.1648 81.0024Z",
    fill: "#41444B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.197 115.423C144.789 107.648 124.341 93.4182 109.457 74.5468C94.5734 55.6754 85.9273 33.0156 84.6195 9.45256C84.3108 3.24223 82.222 -2.76925 78.5795 -7.93035C74.9369 -13.0915 69.8795 -17.2053 63.9554 -19.826C58.0313 -22.4468 51.4665 -23.4744 44.9724 -22.7975C38.4784 -22.1207 32.3029 -19.7652 27.1152 -15.9863C21.9276 -12.2075 17.9256 -7.14942 15.5431 -1.36035C13.1606 4.42872 12.4885 10.7279 13.5995 16.8546C14.7106 22.9813 17.5625 28.7018 21.8461 33.3959C26.1297 38.0901 31.6816 41.579 37.9001 43.4844C61.1511 51.4254 81.408 65.746 96.1121 84.6372C110.816 103.528 119.308 126.143 120.515 149.625C120.51 149.651 120.51 149.678 120.515 149.704C120.927 155.84 123.077 161.755 126.737 166.822C130.397 171.889 135.43 175.918 141.302 178.481C147.174 181.045 153.666 182.048 160.089 181.384C166.512 180.719 172.625 178.412 177.781 174.707C182.937 171.003 186.943 166.038 189.374 160.342C191.804 154.645 192.569 148.428 191.586 142.351C190.603 136.275 187.91 130.564 183.792 125.827C179.674 121.089 174.285 117.501 168.197 115.443V115.423Z",
    fill: "#41444B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonsBg);
export default __webpack_public_path__ + "static/media/buttons_bg.d4d50d28fd7b1598a0397841225fcf4a.svg";
export { ForwardRef as ReactComponent };